import api from "../utils/api";

export const getEstablishments = async (userId: number) => {
  try {        
    const res = await api.get('/api/subusers-links', {
      params: {
        filters: {
          childs: {
            id: {
              $in: [userId]
            }
          }
        },
        populate: {
          parent: {
            fields: ['id', 'username']
          }
        }
      }
    });

    return res.data.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getMembers = async (parentId: number) => {
  try {
    const res = await api.get('/api/subusers-links', {
      params: {
        filters: {
          parent: { id: { $eq: parentId } }
        },
        populate: {
          childs: { fields: ['id', 'username'] }
        }
      }
    });

    const link = res.data.data[0];
    if (!link) return [];

    const sortedChilds = link.childs.sort((a: any, b: any) => {
      return a.attributes.username.localeCompare(b.attributes.username, 'fr', { sensitivity: 'base' });
    });

    return sortedChilds;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const addMembers = async (parentId: number, childIds: number[]) => {
  try {
    const existingRes = await api.get('/api/subusers-links', {
      params: {
        filters: {
          parent: { id: { $eq: parentId } }
        },
        populate: ['childs']
      }
    });

    const existingLink = existingRes.data.data[0];

    if (existingLink) {
      const currentChildIds = existingLink.childs.map((c: any) => c.id);

      const idsToConnect = childIds.filter(id => !currentChildIds.includes(id));

      if (idsToConnect.length === 0) {
        return existingLink;
      }

      const updateRes = await api.put(`/api/subusers-links/${existingLink.documentId}`, {
        data: {
          childs: {
            connect: idsToConnect
          }
        }
      });

      return updateRes.data;
    } else {
      const createRes = await api.post('/api/subusers-links', {
        data: {
          parent: parentId,
          childs: {
            connect: childIds
          }
        }
      });

      return createRes.data;
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const removeMemberById = async (userId: number, relatedUserIdToRemove: number) => {
  try {
    const existingRes = await api.get('/api/subusers-links', {
      params: {
        filters: {
          parent: { id: { $eq: userId } }
        },
        populate: ['childs']
      }
    });

    const existingLink = existingRes.data.data[0];

    if (!existingLink) {
      console.log(`Aucun subusers-link trouvé pour le parent ${userId}`);
      return null;
    }

    const currentChildIds = existingLink.childs.map((c: any) => c.id);
    const updatedChildIds = currentChildIds.filter((id: number) => id !== relatedUserIdToRemove);

    const updateRes = await api.put(`/api/subusers-links/${existingLink.documentId}`, {
      data: {
        childs: updatedChildIds
      }
    });

    return updateRes.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
